/**
 * /imprint — Oeffentliche Impressum-Seite (F-PUBLIC-LEGAL-1)
 *
 * TMG/DDG § 5 verlangt, dass das Impressum OHNE Login erreichbar ist.
 * Diese Top-Level-Route liegt bewusst ausserhalb des `_auth`-Baums und
 * rendert dieselbe ImprintPage-Komponente wie die eingeloggte Ansicht
 * unter /legal/imprint — keine inhaltliche Divergenz, nur ein anderer
 * (oeffentlicher) Navigations-Rahmen (PublicLegalLayout).
 */
import { createFileRoute } from '@tanstack/react-router'
import { PublicLegalLayout } from '../features/legal/PublicLegalLayout'
import { ImprintPage } from '../features/legal/ImprintPage'

export const Route = createFileRoute('/imprint')({
  component: () => (
    <PublicLegalLayout activeTab="imprint">
      <ImprintPage />
    </PublicLegalLayout>
  ),
})
